import type { ConfigType } from "@plone/registry";

export default function install(config: ConfigType) {
  // Language settings
  config.settings.isMultilingual = true;
  config.settings.supportedLanguages = ["en", "pt"];
  config.settings.defaultLanguage = "pt";

  return config;
}
